import React from 'react';
import Card from '@mui/material/Card';
import LzSApp from '@lz-app/App';
import LzSAppBasics from '@lz-app/AppBasics';
import LzXLayoutPublic from '@lz-layouts/LayoutPublic';
import LzXPoweredByLogo from '@lz-layouts/PoweredByLogo';
import { LzPFullPagePublicForm } from './type';

import './styles.scss';

export default function LzXFullPagePublicForm(props: LzPFullPagePublicForm) {
  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (props.onSubmit) {
      props.onSubmit(event);
    }
  };

  return (
    <LzXLayoutPublic noContainer className={props.className} style={props.style}>

      <div className='lz-full-page-form'>
        <Card className='lz-full-page-form-card'>
          <div className='lz-full-page-form-half-form' style={{ backgroundImage: 'url(' + props.bgImg + ')' }}>

            <form noValidate autoComplete='off' onSubmit={(event) => onSubmit(event)}>

              <img src={LzSApp.logo_image} alt={LzSAppBasics.app_name} className='lz-form-logo' />

              <h1>{props.heading}</h1>

              {props.children}

            </form>

          </div>
        </Card>
        <LzXPoweredByLogo />
      </div>

    </LzXLayoutPublic>
  );
}
